import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "filterBtn", "term", "termName", "letterSection", "letterLink", "noResults", "categorySelect"]

  declare readonly categorySelectTargets: HTMLSelectElement[]
  declare readonly searchTarget: HTMLInputElement
  declare readonly filterBtnTargets: HTMLButtonElement[]
  declare readonly termTargets: HTMLElement[]
  declare readonly termNameTargets: HTMLElement[]
  declare readonly letterSectionTargets: HTMLElement[]
  declare readonly letterLinkTargets: HTMLAnchorElement[]
  declare readonly noResultsTarget: HTMLElement

  private activeCategory = "all"

  filterCategory(event: Event) {
    const btn = event.currentTarget as HTMLElement
    this.activeCategory = btn instanceof HTMLSelectElement ? btn.value : btn.dataset.category ?? "all"
    this.categorySelectTargets.forEach(select => { select.value = this.activeCategory })

    this.filterBtnTargets.forEach(b => {
      b.classList.toggle("btn-primary", b.dataset.category === this.activeCategory)
      b.classList.toggle("btn-outline", b.dataset.category !== this.activeCategory)
    })

    this.filter()
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.termTargets.forEach((termEl, i) => {
      const matchesCategory = this.activeCategory === "all" || termEl.dataset.category === this.activeCategory
      const name = this.termNameTargets[i]?.textContent?.toLowerCase() ?? ""
      const matchesSearch = !query || name.includes(query) ||
        termEl.textContent?.toLowerCase().includes(query)

      const visible = matchesCategory && matchesSearch
      termEl.hidden = !visible
      if (visible) visibleCount++
    })

    // Hide letter sections with no visible terms
    this.letterSectionTargets.forEach(section => {
      const hasVisible = Array.from(section.querySelectorAll<HTMLElement>("[data-glossary-filter-target='term']"))
        .some(el => !el.hidden)
      section.hidden = !hasVisible
    })

    // Sync A-Z navigation opacity
    const visibleLetters = new Set(
      this.letterSectionTargets.filter(s => !s.hidden).map(s => s.id.replace("letter-", ""))
    )
    this.letterLinkTargets.forEach(link => {
      const letter = link.textContent?.trim() ?? ""
      link.classList.toggle("opacity-30", !visibleLetters.has(letter))
    })

    // No results — replace {{query}} with actual query (JS placeholder, not Rails %{query})
    this.noResultsTarget.hidden = visibleCount > 0 || !query
    if (!this.noResultsTarget.hidden) {
      const template = this.noResultsTarget.dataset.noResultsTemplate ?? ""
      this.noResultsTarget.textContent = template.replace("{{query}}", query)
    }
  }
}
